<template>
    <div :class="{...marginClass, ...displayClasses}" ></div>
</template>

<script>
    import displayClassesMixin from "./mixin/displayClassesMixin";

    export default {
        name: "MarginTop",
        mixins: [displayClassesMixin],
        props: {
            size: {
                type: String,
                default: "3"
                // todo check to between 1-5
            }
        },
        computed: {
            marginClass() {
                let res = {};

                res['mt-' + this.size] = true

                return res
            }
        }
    }
</script>
